import AllergiesDietScreen from "app/screens/residents/show/AllergiesDietScreen";

export default function ResidentAllergiesDietPage() {
  return <AllergiesDietScreen />;
}
